import React from "react";
import { UserRoles } from "@/entities";

interface Props {
  defaultValue: any;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLSelectElement>) => void;
  value: string;
}
export function UserRoleSelect({
  defaultValue,
  onChange,
  onBlur,
  value,
}: Props) {
  return (
    <select
      className="form-select"
      onChange={onChange}
      onBlur={onBlur}
      value={value}
    >
      <option value={defaultValue.key}>{defaultValue.value}</option>
      {UserRoles?.map((item, index) => {
        return (
          <option key={index} value={item.key}>
            {item.value}
          </option>
        );
      })}
    </select>
  );
}
